import { httpClient } from '@/shared/lib/http-client';
import { API_ENDPOINTS } from '@/shared/config/api';
import type { DashboardStatsResponse } from '@/shared/types';

/**
 * API сервис для панели управления
 * Содержит методы для получения статистики и обзорных данных
 */
export const dashboardApi = {
  /**
   * Получить статистику панели управления
   * @returns Ответ со статистикой
   */
  async getStats(): Promise<DashboardStatsResponse> {
    const response = await httpClient.get<DashboardStatsResponse>(
      API_ENDPOINTS.DASHBOARD.STATS
    );
    return response.data;
  }
};
